import HeaderBasic from 'components/Headers/Basic';
import {FC} from 'react';
import {twMerge} from 'tailwind-merge';

import {SessionStatus} from '../../hooks/useSessionTimer';
import LoggedInMenu from '../LoggedInHeader/LoggedInMenu';

type HeaderProps = {
    className?: string;
    classNameHeader?: string;
    email: string;
    sessionStatus: SessionStatus;
    showLanguage?: boolean;
};

const Header: FC<HeaderProps> = ({
    className,
    classNameHeader,
    email,
    sessionStatus,
    showLanguage = false,
}) => (
    <div
        className={twMerge(
            'bottom-0 flex items-end justify-between ',
            className,
        )}
    >
        <HeaderBasic
            className={classNameHeader}
            showLanguage={showLanguage}
            showSignIn={false}
        />
        <LoggedInMenu email={email} sessionStatus={sessionStatus} />
    </div>
);

export default Header;
